import { render, staticRenderFns } from "./EmployeeRatingNotes.vue?vue&type=template&id=788c5c6e&scoped=true&"
import script from "./EmployeeRatingNotes.vue?vue&type=script&lang=js&"
export * from "./EmployeeRatingNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788c5c6e",
  null
  
)

export default component.exports